import "./es.object.assign-7e79fd7b.js";
import { fpds as T, BREAKPOINTS as b } from "@ucl/shared-component-foundations";
import { c as d } from "./index-8b07dec9.js";
import { useState as W, useEffect as I, useRef as w } from "react";
import f, { css as C } from "styled-components";
import "./es.object.keys-9d66766f.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as M } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { useWindowSize as N } from "./useWindowSize.js";
import { Button as _ } from "./button.js";
import { jsx as u, jsxs as B } from "react/jsx-runtime";
import { a as y } from "./tslib.es6-59e1c9d8.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./combineRefs-c9ad2c39.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
function x(t, o) {
  var r;
  return typeof t == "string" ? o ? ((r = o[t]) !== null && r !== void 0 || (o[t] = document.querySelectorAll(t)), t = o[t]) : t = document.querySelectorAll(t) : t instanceof Element && (t = [t]), Array.from(t || []);
}
const k = {
  any: 0,
  all: 1
};
function S(t, o, { root: r, margin: e, amount: a = "any" } = {}) {
  if (typeof IntersectionObserver > "u")
    return () => {
    };
  const c = x(t), p = /* @__PURE__ */ new WeakMap(), n = (s) => {
    s.forEach((i) => {
      const l = p.get(i.target);
      if (i.isIntersecting !== !!l)
        if (i.isIntersecting) {
          const v = o(i);
          typeof v == "function" ? p.set(i.target, v) : m.unobserve(i.target);
        } else
          l && (l(i), p.delete(i.target));
    });
  }, m = new IntersectionObserver(n, {
    root: r,
    rootMargin: e,
    threshold: typeof a == "number" ? a : k[a]
  });
  return c.forEach((s) => m.observe(s)), () => m.disconnect();
}
function E(t, o) {
  var r = o === void 0 ? {} : o, e = r.root, a = r.margin, c = r.amount, p = r.once, n = p === void 0 ? !1 : p, m = y(W(!1), 2), s = m[0], i = m[1];
  return I(function() {
    var l;
    if (!(!t.current || n && s)) {
      var v = function() {
        return i(!0), n ? void 0 : function() {
          return i(!1);
        };
      }, g = {
        root: (l = e == null ? void 0 : e.current) !== null && l !== void 0 ? l : void 0,
        margin: a,
        amount: c === "some" ? "any" : c
      };
      return S(t.current, v, g);
    }
  }, [e, t, a, n]), s;
}
var D = /* @__PURE__ */ f.div.withConfig({
  displayName: "ctaButton__CTAMainWrapper",
  componentId: "sc-1s7sm03-0"
})(["&.CTAButton-MainWrapper{", ";}"], function(t) {
  var o = t.theme.components.ctaButton;
  return C(o.CTAMainWrapper);
}), O = /* @__PURE__ */ f.div.withConfig({
  displayName: "ctaButton__CTADesktopWrapper",
  componentId: "sc-1s7sm03-1"
})(["&.CTAButton-DesktopWrapper{", ";}"], function(t) {
  var o = t.theme.components.ctaButton;
  return C(o.CTADesktopWrapper);
}), V = /* @__PURE__ */ f.div.withConfig({
  displayName: "ctaButton__CTAMobileWrapper",
  componentId: "sc-1s7sm03-2"
})(["&.CTAButton-MobileWrapper{", ";}"], function(t) {
  var o = t.theme.components.ctaButton;
  return C(o.CTAMobileWrapper);
}), A = /* @__PURE__ */ f.div.withConfig({
  displayName: "ctaButton__CTATitle",
  componentId: "sc-1s7sm03-3"
})(["&.CTAButton-Title{", ";}"], function(t) {
  var o = t.theme.components.ctaButton;
  return C(o.CTATitle);
}), P = /* @__PURE__ */ f.div.withConfig({
  displayName: "ctaButton__CTAButtonWrapper",
  componentId: "sc-1s7sm03-4"
})(["&.CTAButton-ButtonWrapper{", ";}"], function(t) {
  var o = t.theme.components.ctaButton;
  return C(o.CTAButtonWrapper);
}), j = /* @__PURE__ */ f.button.withConfig({
  displayName: "ctaButton__CTAButtonContact",
  componentId: "sc-1s7sm03-5"
})(["@keyframes slide-in-out{0%,12%,100%{right:100%;}6%{right:0%;}}@keyframes textColorChange{0%,12%,100%{color:var(--animateTextFill,'", "');}6%{color:var(--animateTextDefault,'", "');}}&.CTAButton-Btn-Contact{", ";}"], T.semantic.color.text.primaryStrong, T.semantic.color.text.onColor, function(t) {
  var o = t.theme.components.ctaButton;
  return C(o.CTAButtonContact);
}), h = function(o) {
  var r = o.contact, e = o.isMobile, a = e === void 0 ? !1 : e, c = o.onClick, p = w(null), n = E(p);
  return /* @__PURE__ */ u(j, {
    ref: p,
    $isMobile: a,
    onClick: c,
    className: d("CTAButton-Btn-Contact", {
      mobile: a
    }, {
      animate: n
    }),
    tabIndex: a ? 0 : -1,
    children: /* @__PURE__ */ u("span", {
      className: "contact",
      children: r
    })
  });
}, Qt = function(o) {
  var r = o.titleText, e = r === void 0 ? "Software Sales Support:" : r, a = o.className, c = o.onClick, p = o.contact, n = o.buttonProps, m = M({
    label: "CTAButton"
  }), s = N(), i = s.width;
  return /* @__PURE__ */ u(D, Object.assign({
    className: d(["CTAButton-MainWrapper", a])
  }, m, {
    children: i > b.tabletMin ? /* @__PURE__ */ B(O, {
      className: d(["CTAButton-DesktopWrapper"]),
      children: [/* @__PURE__ */ u(A, {
        className: d(["CTAButton-Title"]),
        children: e
      }), /* @__PURE__ */ u(h, {
        contact: p
      })]
    }) : /* @__PURE__ */ B(V, {
      className: d(["CTAButton-MobileWrapper"]),
      children: [/* @__PURE__ */ u(A, {
        className: d(["CTAButton-Title"]),
        children: e
      }), /* @__PURE__ */ B(P, {
        className: d(["CTAButton-ButtonWrapper"]),
        children: [/* @__PURE__ */ u(h, {
          contact: p,
          onClick: c,
          isMobile: !0
        }), /* @__PURE__ */ u(_, {
          variant: "secondary",
          onClick: c,
          leftIcon: n == null ? void 0 : n.leadingIcon,
          rightIcon: n == null ? void 0 : n.trailingIcon,
          children: (n == null ? void 0 : n.buttonText) || "Call Now"
        })]
      })]
    })
  }));
};
export {
  Qt as CTAButton
};
